module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/Projects/milic/self-legal/src/app/app-container/app.container.html
// module id = ../../../../../src/app/app-container/app.container.html
// module chunks = main